import { format, formatDistanceToNow, getTime } from 'date-fns';
import { match, P } from 'ts-pattern';

import { CountryCode } from '@zep/types';
// ----------------------------------------------------------------------

type InputValue = Date | string | number | null;

export function fDate(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'yyyy.MM.dd';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date: InputValue) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date: InputValue) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function fYearMonth(date: Date | string | number) {
  return format(new Date(date), 'yyyy년 M월');
}

export function fYearMonthDay(date: Date | string | number) {
  return format(new Date(date), 'yyyy년 M월 dd일');
}

const SIMPLE_DATE_REGEX = /\d{4}(.\d{2}){2}/;
const SIMPLE_DATE_TIME_REGEX = /\d{4}(.\d{2}){2}(\s|T)(\d{2}.){2}\d{2}/;
const ISO_8601_FULL =
  /^(\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(\.\d{3})?(Z|([+-])([01]\d|2[0-3]):[0-5]\d)?$/;

export const newDate = (dateInput: InputValue): Date =>
  match<InputValue, Date>(dateInput)
    .with(P.string.regex(ISO_8601_FULL), dateString => {
      return new Date(dateString);
    })
    .with(
      P.string.regex(SIMPLE_DATE_REGEX),
      P.string.regex(SIMPLE_DATE_TIME_REGEX),
      dateString => {
        const tmpDate = new Date(dateString);
        const userTimezoneOffset = tmpDate.getTimezoneOffset() * 60 * 1000;
        return new Date(tmpDate.getTime() - userTimezoneOffset);
      },
    )
    .with(P.string, () => {
      return new Date();
    })
    .with(P.instanceOf(Date), date => date)
    .with(P.number, timestamp => new Date(timestamp))
    .otherwise(() => new Date());

export const fDateByCountryCode = (
  dateInput: InputValue,
  countryCode: CountryCode,
) => {
  const date = newDate(dateInput);
  return match(countryCode)
    .with('KR', 'JP', () => format(date, `yyyy. MM. dd`))
    .otherwise(() => format(date, `MMM. dd. yyyy`));
};

export const fDateTimeByCountryCode = (
  dateInput: InputValue,
  countryCode: CountryCode,
) => {
  const date = newDate(dateInput);
  return match(countryCode)
    .with('KR', 'JP', () => format(date, `yyyy. MM. dd, hh:mm a`))
    .otherwise(() => format(date, `MMM. dd. yyyy, hh:mm a`));
};
